import '.d{display:flex;}.ssr-plugin'
import '.r{align-items:stretch;}.ssr-plugin'
import '.af{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.eg{background:var(--palette-white);}.ssr-plugin'
import '.ah{flex-grow:1;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.ai{max-width:77.5rem;}.ssr-plugin'
import '.ge{justify-content:stretch;}.ssr-plugin'
import '.be{position:sticky;}.ssr-plugin'
import '.bf{top:0px;}.ssr-plugin'
import '.bj{z-index:10;}.ssr-plugin'
import '.g4{padding-block:1rem;}.ssr-plugin'
import '.g5{height:3rem;}.ssr-plugin'
import '.al{justify-content:space-between;}.ssr-plugin'
import '.ao{flex-wrap:wrap;}.ssr-plugin'
import '.gg{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.fl{margin-top:2rem;}.ssr-plugin'
import '.ga{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const CreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="d r af e eg"
      >
        <div className="ah d t af e"
        >
          <div className="l ai d e ge be bf bj"
            style={{
              paddingInline: isMobile ? '2rem' : 0,}}
          >
            <nav className="g4 g5 d al t ao"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="gg d e r fl ga l ai"
            style={{
              gap: gap, // 8rem is padding + navbar height
              paddingInline: isMobile ? '2rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
